// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"5d080f73","71":"04139a77","95":"e8ee70f4","113":"a3dca5d6","142":"475c3442","438":"cd0a6c9e","538":"2128bc0c","592":"5bc62d0a","648":"66d2a00d","758":"99934655","798":"c848859b"}[chunkId] + ".chunk.js";
};